import React from "react";
import { FirebaseApp } from "firebase/app";
import { Auth } from "firebase/auth";
import { Firestore } from "firebase/firestore";
import { FirebaseStorage } from "firebase/storage";

import {
  firebaseApp,
  firebaseAuth,
  firebaseFirestore,
  firebaseStorage,
} from "./FirebaseInterface";

interface IFirebaseContext {
  app: FirebaseApp;
  auth: Auth;
  firestore: Firestore;
  storage: FirebaseStorage;
}

const FirebaseContext: React.Context<IFirebaseContext> =
  React.createContext<IFirebaseContext>({
    app: firebaseApp,
    auth: firebaseAuth,
    firestore: firebaseFirestore,
    storage: firebaseStorage,
  });

export { FirebaseContext, type IFirebaseContext };
